// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_fullcalendar_angular___ivy_ngcc___fesm2015_fullcalendar-angular_js":"ab809ba6b54da394","src_app_calendar_calendar_module_ts":"afb934f9ee46e51c"}[chunkId] + ".css";
};